<template>

  <v-data-table
    :headers="headers"
    :items="_items"
    :server-items-length="_total"
    :footer-props="footer"
    :no-data-text="labels.nodata"
    :options.sync="options"
    :loading="loading"
    @click:row="$emit('click', $event)"
  >
    <template v-slot:item.assetTypes.name="{ item }">
      <template v-if="item.assetType">{{ item.assetType.name }}</template>
    </template>

    <template v-slot:item.actions="{ item }">
      <responsive-icon :label="$t('assets.edit')" breakpoints="xs">
        <font-awesome-icon icon="pen" size="lg"></font-awesome-icon>
      </responsive-icon>
    </template>
  </v-data-table>

</template>

<script>

  import dataTable from '../../helpers/data-table.es6'
  import ResponsiveIcon from '../../shared/components/responsive-icon'

  export default {
    name: 'assets-table',
    mixins: [ dataTable ],

    data () {
      return {
        sortRules: {
          assets: 'assets.name'
        },
        headers: [
          { text: this.$t('name'), value: 'assetParentsView.fullPath', sortable: true },
          { text: this.$tc('asset-types.entity-name', 1), value: 'assetTypes.name', sortable: true },
          { text: this.$t('devices.type'), value: 'deviceType', sortable: true },
          { text: this.$t('shared.actions'), value: 'actions', sortable: false },
        ]
      }
    },

    components: {
      ResponsiveIcon
    },
  }
</script>

<style scoped lang="scss">

</style>
